import { createCxApiClient } from '@mangovoice/api-client'

import type { components, paths } from './generated/schema'

export type MargoCallReport = components['schemas']['Report']
export type MargoCallReportError = components['schemas']['Error']

export const MARGO_CALL_REPORT_PATH = '/margo/call-analytics/v1/report' as const

export function createMargoCallAnalyticsClient(
  transport: Parameters<typeof createCxApiClient>[0],
) {
  const client = createCxApiClient<paths>(transport)

  return {
    getCallReport(callId: number, pbxId: number) {
      const { get } = client(MARGO_CALL_REPORT_PATH)()
      if (!get) {
        throw new Error(
          `GET ${MARGO_CALL_REPORT_PATH} is missing from the generated client`,
        )
      }

      return get({ call_id: callId, pbx_id: pbxId })
    },
  }
}

export type MargoCallAnalyticsClient = ReturnType<
  typeof createMargoCallAnalyticsClient
>
